// Dev-only error logging. In production this is a no-op so we don't leak
// internals to the browser console (swap for Sentry etc. if needed later).
export const logError = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
